export function timeFix() {
  const time = new Date();
  const hour = time.getHours();
  return hour < 9
    ? "早上好"
    : hour <= 11
    ? "上午好"
    : hour <= 13
    ? "中午好"
    : hour < 20
    ? "下午好"
    : "晚上好";
}

export function welcome() {
  const arr = [
    "休息一会儿吧",
    "准备吃什么呢?",
    "要不要打一把 DOTA",
    "我猜你可能累了",
  ];
  const index = Math.floor(Math.random() * arr.length);
  return arr[index];
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent("HTMLEvents");
  event.initEvent("resize", true, true);
  event.eventType = "message";
  window.dispatchEvent(event);
}

export function handleScrollHeader(callback) {
  let timer = 0;

  let beforeScrollTop = window.pageYOffset;
  callback = callback || function() {};
  window.addEventListener(
    "scroll",
    () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        let direction = "up";
        const afterScrollTop = window.pageYOffset;
        const delta = afterScrollTop - beforeScrollTop;
        if (delta === 0) {
          return false;
        }
        direction = delta > 0 ? "down" : "up";
        callback(direction);
        beforeScrollTop = afterScrollTop;
      }, 50);
    },
    false
  );
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = "", timeout = 1500) {
  if (id === "") {
    return;
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id));
  }, timeout);
}

// 经过封装的自定义事件，作用于点击左侧menu时切换自定义表单
export const triggerWindowEvent = (eName) => {
  const event = window.document.createEvent("Event");
  event.initEvent(eName, true, true);
  return event;
};

export const triggerWindowAddEvent = (eName, fn) => {
  window.addEventListener(eName, fn, false);
};

// 监听postmessage事件
export const addPostMessageEvent = (handle) => {
  window.addEventListener("message", ({ data }) => {
    if (data.action) {
      handle(data);
    }
  });
};

// 修改页面的title
export const setDocumentTitle = (title) => {
  document.title = title;
};

export const symbolReplaces = [/↵/g];
export const filterRouterCustomField = (customField) => {
  for (let i = 0; i < symbolReplaces.length; i++) {
    if (customField) {
      customField.replace(symbolReplaces[i], "");
    }
  }

  try {
    return JSON.parse(customField);
  } catch (error) {
    return {};
  }
};
export const getCustomField = (item) => {
  const isFrame = ["form", "table", "plainUrl"].includes(item.scheme);
  let filterRouterCustomField = {
    name: isFrame ? item.menuCode : item.path,
    key: isFrame ? item.menuCode : item.path,
    title: item.status ? item.menuName : "",
    isShow: item.status,
    pageType: item.scheme,
    iframePath: item.path,
  };
  if (item.menuCode === "list") {
    filterRouterCustomField = {
      ...filterRouterCustomField,
      oti: "3430477547783168",
      eti: "3431722765468672",
      ofc: "enterprise_20191016",
    };
  }
  if (!isFrame) {
    Reflect.deleteProperty(filterRouterCustomField, "iframePath");
  }
  return filterRouterCustomField;
};
